// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"2485d0b6","266":"4013aa2a","611":"ed52bec2","887":"941d1531"}[chunkId] + ".chunk.js";
};